import { useSEO } from '@/hooks/useSEO';
import { SocialSidebar } from '../../components/feature/SocialSidebar';
import { EDKHero } from './components/EDKHero';
import { EDKProblems } from './components/EDKProblems';
import { EDKContents } from './components/EDKContents';
import { EDKPurchase } from './components/EDKPurchase';

const EvilEnergyDestroyKitPage = () => {
  useSEO({
    title: 'Evil Energy Destroy Kit | ZpiritualZ - Complete Ritueel Beschermingskit',
    description: 'De Evil Energy Destroy Kit van ZpiritualZ: alles wat je nodig hebt in één complete set. Verwijder negatieve energie, bescherm je huis en herstel je innerlijke balans met onze krachtigste ritueel bundel.',
    canonical: 'https://www.zpiritualz.com/evil-energy-destroy-kit',
    ogImage: 'https://public.readdy.ai/ai/img_res/4e21e05f4115867ee5e58d4c7e0ae610.jpg',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'Evil Energy Destroy Kit Compleet',
        description: 'Compleet doe-het-zelf pakket voor extreme gevallen — speciaal voor baby- en kinderkamers, het betreden van een nieuwe woning of zaak, en voor volwassenen die een aanwezigheid van een entiteit waarnemen.',
        url: 'https://www.zpiritualz.com/evil-energy-destroy-kit',
        brand: {
          '@type': 'Brand',
          name: 'ZpiritualZ',
        },
        offers: {
          '@type': 'Offer',
          price: '79.95',
          priceCurrency: 'EUR',
          availability: 'https://schema.org/InStock',
          url: 'https://www.zpiritualz.com/shop/edk-1',
          seller: {
            '@type': 'Organization',
            name: 'ZpiritualZ',
          },
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '4.9',
          reviewCount: '127',
          bestRating: '5',
          worstRating: '1',
        },
        review: [
          {
            '@type': 'Review',
            author: { '@type': 'Person', name: 'Sharona K.' },
            reviewRating: { '@type': 'Rating', ratingValue: '5' },
            reviewBody: 'Mijn baby sliep al weken niet door. Na het ritueel was het die nacht meteen rustiger. Ik huilde van opluchting.',
          },
          {
            '@type': 'Review',
            author: { '@type': 'Person', name: 'Aziz M.' },
            reviewRating: { '@type': 'Rating', ratingValue: '5' },
            reviewBody: 'Nieuwe zaak op een plek waar drie bedrijven eerder failliet gingen. Na de Destroy Kit draaien we eindelijk winst.',
          },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Voor wie is de Evil Energy Destroy Kit bedoeld?',
            acceptedAnswer: { '@type': 'Answer', text: 'De kit is speciaal bedoeld voor extreme gevallen: baby- en kinderkamers bij herhaaldelijk schrikken, nieuwe woningen of zaken met een negatief verleden, en voor volwassenen die een aanwezigheid van een entiteit waarnemen.' },
          },
          {
            '@type': 'Question',
            name: 'Wat zit er in de Evil Energy Destroy Kit?',
            acceptedAnswer: { '@type': 'Answer', text: 'De kit bevat: een exclusieve Blueprint met stap-voor-stap instructies, een unieke kruidenwierookmix (Salie-extracten, Ghandak, Pepper, Hing, Lobhan), een Abalone Schelp, een Uilenveer, Brandkool en een Witte Kaars.' },
          },
          {
            '@type': 'Question',
            name: 'Hoe gebruik ik de Evil Energy Destroy Kit?',
            acceptedAnswer: { '@type': 'Answer', text: 'Volg de bijgevoegde Blueprint stap voor stap. Begin met de voorbereiding: reinig jezelf en zet je intentie neer met de witte kaars. Steek het brandkool aan in de abaloneschelp, voeg de kruidenmix toe en beweeg de rook met de uilenveer door de ruimte.' },
          },
        ],
      },
    ],
  });

  return (
  <div className="min-h-screen bg-[#080000]">
    <SocialSidebar />

    <EDKHero />
    <EDKProblems />
    <EDKContents />
    <EDKPurchase />

    {/* Sticky bottom nav */}
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-40 hidden lg:flex items-center gap-1 px-3 py-2 bg-[#100000]/80 backdrop-blur-xl border border-orange-500/20 rounded-full">
      {[
        { href: '#problemen', label: 'Problemen', icon: 'ri-error-warning-line' },
        { href: '#inhoud', label: 'Kit Inhoud', icon: 'ri-box-3-line' },
      ].map(item => (
        <a
          key={item.href}
          href={item.href}
          className="flex items-center gap-1.5 px-4 py-2 rounded-full text-white/45 hover:text-orange-300 hover:bg-orange-900/20 transition-all text-xs font-medium cursor-pointer whitespace-nowrap"
        >
          <div className="w-3.5 h-3.5 flex items-center justify-center">
            <i className={`${item.icon} text-xs`} />
          </div>
          {item.label}
        </a>
      ))}
    </div>
  </div>
  );
};

export default EvilEnergyDestroyKitPage;
